import { connect, screenreaderNotification, pinSessionItem, getActiveQuizSession } from '@instructure/quiz-core';
import { TakingSidebarItem as SidebarItem } from './presenter';
function mapStateToProps(state, ownProps) {
  var quizSession = getActiveQuizSession(state);
  var isAnswered = state.getIn(['taking', 'responses', ownProps.position]) !== void 0;
  return {
    isPinned: quizSession.pins().includes(ownProps.position),
    isAnswered: isAnswered,
    quizSession: quizSession
  };
}
var mapDispatchToProps = {
  screenreaderNotification: screenreaderNotification,
  pinSessionItem: pinSessionItem
};
export var TakingSidebarItem = connect(mapStateToProps, mapDispatchToProps)(SidebarItem);
export default TakingSidebarItem;